import { render } from "./Fishing.vue?vue&type=template&id=16d2e27a&scoped=true"
import script from "./Fishing.vue?vue&type=script&lang=js"
export * from "./Fishing.vue?vue&type=script&lang=js"

import "./Fishing.vue?vue&type=style&index=0&id=16d2e27a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d2e27a"]])

export default __exports__